var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCore4ArmVelocity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440.56 370.62",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,367.48l152.41-130.46,85.72-71.73-9.49-21.41L41.81,277.68l-1.81-2.19,76.18-66.95,107.12-91.94.63-26.76-144.36,101.92-2.29-2.57L248.36,38.86c42.61-49.01,115.95-52.54,161.66-5.6,25.01,26.3,35.61,61.81,28.24,98.93-6.39,32.2-28.55,58.48-59.01,76.28l-99.39,67.85c-29.58,20.19-56.63,41.02-89.08,58.91l133.39-116.73-26.6-5.88-198.04,140.87-2.07-2.47,175.37-150.2-18.99-15.43L1.07,370.62l-1.07-3.14ZM334.16,15.27c-50.05-.92-89.72,36.59-94.96,83.75,48.16-2.83,89.3-37.5,94.96-83.75ZM313.54,200.64c10.39-56.61,55.78-94.3,111.32-98.26-2.67-41.95-33.27-76.77-74.73-85.28-8.66,55.45-55.68,94.61-111.43,97.27,2.68,43.43,33.78,78.12,74.84,86.27ZM328.51,202.78c48.93,1.56,91.18-34.63,96.73-85.18-47.74,2.95-87.86,37.07-96.73,85.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCore4ArmVelocity);
export default __webpack_public_path__ + "static/media/ico-core4ArmVelocity.8debfde2.svg";
export { ForwardRef as ReactComponent };